import {pullRequestFeedbackAutomatedReviewCommentPath} from '@github-ui/paths'

export function useAutomatedReviewFeedback(automatedCommentId: string, basePath: string) {
  const feedbackPath = pullRequestFeedbackAutomatedReviewCommentPath({
    basePath,
    automatedReviewCommentId: automatedCommentId,
  })

  return {
    feedbackPath,
  }
}
